module.exports = __webpack_public_path__ + "img/-LV0wo_2D8OID0Sqo6mW.6605ebe9.jpg";